import { DatePatternBaseDto, DayType } from './date-pattern-base-dto';

export class DatePatternYearlyDto extends DatePatternBaseDto {
  months: DatePatternYearlyMonthDto[];
  useCustomStartTask: boolean;
}

export class DatePatternYearlyMonthDto {
  days: number[];
  workingDays: number[];
  deviation: number;
  deviationType: DayType;
  month: Months;
  customNumberOfDaysToStartBeforeDeadline: number;
  customDaysToStartBeforeDeadlineType: DayType;
}

export enum Months {
  January = 'January',
  February = 'February',
  March = 'March',
  April = 'April',
  May = 'May',
  June = 'June',
  July = 'July',
  August = 'August',
  September = 'September',
  October = 'October',
  November = 'November',
  December = 'December'
}
